export const useParseText = () => {
    const parseText = (text: string) => ({
        __html: text,
    });

    return { parseText };
};